import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const ChevronsRight = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M 11.394531 13.480469 C 11.96875 12.90625 12.875 12.871094 13.488281 13.371094 L 13.605469 13.480469 L 24.023438 23.894531 L 24.128906 24.011719 C 24.597656 24.585938 24.597656 25.414062 24.128906 25.988281 L 24.023438 26.105469 L 13.605469 36.523438 C 12.996094 37.132812 12.003906 37.132812 11.394531 36.523438 C 10.785156 35.910156 10.785156 34.921875 11.394531 34.3125 L 20.707031 25 L 11.394531 15.6875 L 11.289062 15.570312 C 10.785156 14.957031 10.824219 14.050781 11.394531 13.480469 Z M 25.980469 13.480469 C 26.550781 12.90625 27.457031 12.871094 28.070312 13.371094 L 28.1875 13.480469 L 38.605469 23.894531 L 38.710938 24.011719 C 39.179688 24.585938 39.179688 25.414062 38.710938 25.988281 L 38.605469 26.105469 L 28.1875 36.523438 C 27.578125 37.132812 26.589844 37.132812 25.980469 36.523438 C 25.367188 35.910156 25.367188 34.921875 25.980469 34.3125 L 35.289062 25 L 25.980469 15.6875 L 25.871094 15.570312 C 25.371094 14.957031 25.40625 14.050781 25.980469 13.480469 Z M 25.980469 13.480469 "
        fill={color}
      />
    </svg>
  )
}
